import { useQuery } from "@tanstack/react-query"

import { getLiveForHireMetrics } from "@/features/logistics/api/getLiveForHireMetrics.ts"

import MetricDisplay from "../MetricDisplay.tsx"
import MetricsCard from "../MetricsCard.tsx"

export default function ForHireDailyDisplay() {
  const { data, isPending, isError } = useQuery({
    queryKey: ["liveForHireMetrics", "Daily"],
    queryFn: () => getLiveForHireMetrics("Daily"),
    refetchInterval: 5000,
  })
  return (
    <MetricsCard title="Daily Totals">
      <div className="flex justify-between gap-4">
        <MetricDisplay
          label="Revenue Total"
          value={data ? data.dailyRevenue : 0}
          loading={isPending}
          error={isError}
          unit="$"
        />
        <MetricDisplay
          label="Revenue per Active Truck"
          value={data ? data.revenuePerUsedTruck : 0}
          loading={isPending}
          error={isError}
          unit="$"
        />
      </div>
      <MetricDisplay
        label="Completed Trips"
        value={data ? data.tripsCompleted : 0}
        loading={isPending}
        error={isError}
        unit="#"
      />
      <MetricDisplay
        label="Miles Driven"
        value={data ? data.milesDriven : 0}
        loading={isPending}
        error={isError}
      />
      <MetricDisplay
        label="Fuel Consumed"
        value={data ? data.fuelConsumed : 0}
        loading={isPending}
        error={isError}
        unit="MMBtu"
      />
    </MetricsCard>
  )
}
